const state = {
  post: {},
  posts: JSON.parse(sessionStorage.getItem('posts')) || [],
  post_error: null,
  posts_error: null,
};

const mutations = {
  posts(state) {
    state.posts_error = null;
  },
  postsFailed(state, payload) {
    state.posts_error = payload.error;
  },
  postsSuccess(state, payload) {
    state.posts_error = null;
    state.posts = payload;

    sessionStorage.setItem('posts', JSON.stringify(state.posts));
  },
  post(state) {
    state.post_error = null;
  },
  postFailed(state, payload) {
    state.post_error = payload.error;
  },
  postSuccess(state, payload) {
    state.post_error = null;
    state.post = payload;
  },
};

const actions = {
  posts: ({ commit }) => commit('posts'),
  post: ({ commit }) => commit('post'),
};

const getters = {
  postsError: (state) => state.posts_error,
  postError: (state) => state.post_error,
  posts: (state) => state.posts,
  post: (state) => state.post,
};

export default {
  state,
  mutations,
  actions,
  getters,
};
